import { STATUS, STATUS_PILL_CLASS } from "../constants";
import { formatStatus } from "../utils";

export default function StatusToggle({
  programTitle,
  status,
  disabled,
  isUpdating,
  onToggle,
}) {
  const isActive = status === STATUS.ACTIVE;
  const statusLabel = formatStatus(status);

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        role="switch"
        aria-checked={isActive}
        aria-label={`Set ${programTitle || "program"} ${isActive ? "inactive" : "active"}`}
        disabled={disabled}
        onClick={onToggle}
        className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
          isActive ? "bg-cyan-500" : "bg-gray-200"
        }`}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
            isActive ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </button>
      <span
        className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${
          STATUS_PILL_CLASS[status] || "bg-slate-100 text-slate-700"
        }`}
      >
        {isUpdating ? "Updating..." : statusLabel}
      </span>
    </div>
  );
}
